// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1BsOU","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__atlvh"};